export function useOnPaginate(page, callback, params = null) {
  let paramsObj = params ?? this.params;
  paramsObj.page = page;

  callback();
}

export function useOnSearch(searchValue, callback, params = null) {
  let paramsObj = params ?? this.params;

  if (!paramsObj.filter)
    paramsObj.filter = {};

  paramsObj.filter.search = searchValue?.length ? searchValue : undefined;
  paramsObj.page = 1;

  callback();
}

export function useOnFilter(filter, callback, params = null) {
  let paramsObj = params ?? this.params;

  if (!paramsObj.filter)
    paramsObj.filter = {};

  paramsObj.filter = { ...paramsObj.filter, ...filter }
  paramsObj.page = 1;

  callback();
}